import { useEffect, useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import useUiuxStore from "src/store/useUiuxStore";
import { useMouseContent } from "src/utils/mouse/mouseContent";
import { Content_MST4040_R01 } from "./Content_MST4040_R01";
import { Info_MST4040_R01 } from "./Info_MST4040_R01";
import { SearchSection_MST4040_R01 } from "./SearchSection_MST4040_R01";
import { Table_MST4040_R01 } from "./Table_MST4040_R01";
import { useMST4040_R01Store } from "./Store_MST4040_R01";
import { MST4040_R01Dto } from "./Dto_MST4040_R01";

export const Container_MST4040_R01 = () => {
	const {
		selectedMST4040_R01,
		editMST4040_R01,
	} = useMST4040_R01Store();

	const { setMessage } = useUiuxStore();

	const [buttonDisabled, setButtonDisabled] = useState({
		fetch: false,
		create: false,
		delete: true,
		save: true,
		print: true,
		excel: true,
		init: false,
	});

	const gridRef = useRef<AgGridReact<MST4040_R01Dto>>(null);

	useEffect(() => {
		setButtonDisabled((prev) => ({
			...prev,
			delete: !selectedMST4040_R01,
			save: !selectedMST4040_R01 && !editMST4040_R01.moldCd,
			print: !selectedMST4040_R01,
			excel: !selectedMST4040_R01,
		}));
	}, [selectedMST4040_R01, editMST4040_R01]);

	const RESIZER = {
		code: 'MST4040_R01',
		type: 'height',
		storageKey: 'MST4040_R01-split-height',
		min: 5,
		max: 80,
		default: 40,
	} as const;

	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	const {
		splitValue,
		handleMouseDown,
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef,
	});

	const {
		handleExcelClick,
		fetchData,
		defaultMST4040_R01Row,
		initContainerData,
		handleCreateClick,
		handleDeleteClick,
		handleSaveClick,
	} = Content_MST4040_R01({
		gridRef,
		setMessage,
	});

	return (
		<div className="content-container">
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={handleCreateClick}
				onDeleteClick={handleDeleteClick}
				onSaveClick={handleSaveClick}
				onExcelClick={handleExcelClick}
				onInitClick={initContainerData}
			/>
			<SearchSection_MST4040_R01 />
			<div className="flex-1 flex flex-col p-[12px] gap-[4px]" ref={containerRef}>
				<div className="w-full" style={{ height: `${splitValue}%` }} ref={infoRef}>
					<Info_MST4040_R01 defaultMST4040_R01Row={defaultMST4040_R01Row()} />
				</div>
				<div
					className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
					onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown("UD", e.nativeEvent)}
					onDragStart={(e: React.DragEvent<HTMLDivElement>) => e.preventDefault()}
				/>
				<div className="w-full" style={{ height: `${100 - splitValue}%` }}>
					<Table_MST4040_R01 gridRef={gridRef} defaultMST4040_R01Row={defaultMST4040_R01Row()} />
				</div>
			</div>
			<Message />
		</div>
	);
};
